/**
 * LanguageChooser Component
 * Language selector for switching between available languages
 *
 * DDD Layer: UI (Presentation)
 * Responsibilities:
 * - Render language selection dropdown with flag icons
 * - Handle language change events
 */
import React from 'react';
import { Box } from '@chakra-ui/react';
import { useLanguageChooser } from './useLanguageChooser';
import LanguageSelect from './LanguageSelect';
import './LanguageChooser.scss';

interface LanguageChooserProps {
  className?: string;
  width?: number;
  height?: number;
}

const LanguageChooser: React.FC<LanguageChooserProps> = ({
  className = '',
  width = 230,
  height = 36,
}) => {
  const { languageOptions, currentLanguage, handleLanguageChange } =
    useLanguageChooser();

  return (
    <Box
      className={`language-chooser ${className}`}
      width={`${width}px`}
      display='flex'
      alignItems='center'
      height={`${height}px`}
    >
      <LanguageSelect
        options={languageOptions}
        value={currentLanguage}
        onChange={handleLanguageChange}
        placeholder='Select language'
      />
    </Box>
  );
};

export default LanguageChooser;
